import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Paper, Typography } from "@mui/material";
var StagePanel = function (_a) {
    var title = _a.title, description = _a.description, children = _a.children, footer = _a.footer;
    return (_jsxs(Paper, { variant: "outlined", sx: {
            p: { xs: 2, md: 3 },
            borderRadius: 2,
            borderLeft: 4,
            borderLeftColor: "primary.main",
            background: "linear-gradient(135deg, #ffffff 0%, #f7faff 100%)",
            boxShadow: "0 4px 20px rgba(13, 71, 161, 0.08)",
            transition: "box-shadow 0.3s ease",
            animation: "bulkStageFadeIn 0.35s ease",
            "@keyframes bulkStageFadeIn": {
                from: { opacity: 0, transform: "translateY(8px)" },
                to: { opacity: 1, transform: "translateY(0)" },
            },
        }, children: [_jsx(Typography, { className: "normal-text large-bold", component: "h2", mb: description ? 0.5 : 2.5, children: title }), description ? (_jsx(Typography, { variant: "body2", color: "text.secondary", mb: 2.5, children: description })) : null, _jsx(Box, { children: children }), footer && _jsx(Box, { mt: 3, children: footer })] }));
};
export default StagePanel;
